import Vue from 'vue';
import axios from 'axios';
import i18n from '@/i18n';

export default {
  baseURL: process.env.BASE_URL + 'api/reports',

  getCheckReport(surveyInstanceId, options, cancelToken) {
    return axios.get('get-check-report',
      {
        baseURL: this.baseURL,
        params: {
          'survey-instance-id': surveyInstanceId,
          'localization-id': (options && options.localizationId) ? options.localizationId : null,
          'target-group': (options && options.targetGroup) ? options.targetGroup : null,
        },
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getCheckReports(surveyInstanceIds, options, cancelToken) {
    return axios.post('get-check-reports', {
        'SurveyInstanceIds': surveyInstanceIds,
        'UseSurveyDefaultLocalization': (options && options.useSurveyDefaultLocalization !== undefined) ? options.useSurveyDefaultLocalization : true
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getRawData(filter, options, cancelToken) {
    return axios.get('get-raw-data',
      {
        baseURL: this.baseURL,
        params: {
          'survey-id': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds[0] : null,
          'is-quality-assurance': options ? options.isQualityAssurance : null,
          'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
          'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
          'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
          'target-group': filter ? filter.targetGroup : null,
          'survey-instance-status-minimum': filter ? filter.surveyInstanceStatusMinimum : null,
          'survey-instance-status-maximum': filter ? filter.surveyInstanceStatusMaximum : null,
          'kpi-ids': (filter && _.size(filter.kpiIds) > 0) ? filter.kpiIds.join() : null,
          'include-kpi-points': options ? options.includeKpiPoints : null,
          'include-kpi-percentages':  options ? options.includeKpiPercentages : null,
          'include-cluster-points': options ? options.includeClusterPoints : null,
          'include-cluster-percentages':  options ? options.includeClusterPercentages : null,
          'include-location-info': options ? options.includeLocationInfo : null,
          'include-properties': options ? options.includeProperties : null,
          'include-questions-without-answers': options ? options.includeQuestionsWithoutAnswers : null,
          'include-testchecks': filter ? filter.includeTestchecks : null,
          'include-overall-points': options ? options.includeOverallPoints : null,
          'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale
        },
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getRawDataIdPoints(filter, options, cancelToken) {
    return axios.get('get-raw-data-id-points',
      {
        baseURL: this.baseURL,
        params: {
          'survey-id': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds[0] : null,
          'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
          'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
          'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
          'survey-instance-status-minimum': filter ? filter.surveyInstanceStatusMinimum : null,
          'survey-instance-status-maximum': filter ? filter.surveyInstanceStatusMaximum : null,
          'include-check-info': options ? options.includeCheckInfo : null,
          'include-location-info': options ? options.includeLocationInfo : null,
          'include-testchecks': filter ? filter.includeTestchecks : null,
          'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale
        },
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },

  getFrequencies(filter, options, cancelToken) {
    return axios.get('get-frequencies',
      {
        baseURL: this.baseURL,
        params: {
          'survey-id': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds[0] : null,
          'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
          'scenario-ids': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
          'property-ids': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
          'aggregation-level': options ? options.aggregationLevel : null,
          'survey-instance-status-minimum': filter ? filter.surveyInstanceStatusMinimum : null,
          'survey-instance-status-maximum': filter ? filter.surveyInstanceStatusMaximum : null,
          'include-testchecks': filter ? filter.includeTestchecks : null,
          'localization-id': (options && options.localizationId) ? options.localizationId : i18n.locale
        },
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },
};
